import { render, staticRenderFns } from "./ScreenReporteVentas.vue?vue&type=template&id=cb071118&scoped=true"
import script from "./ScreenReporteVentas.vue?vue&type=script&lang=js"
export * from "./ScreenReporteVentas.vue?vue&type=script&lang=js"
import style0 from "./ScreenReporteVentas.vue?vue&type=style&index=0&id=cb071118&prod&scoped=true&lang=css"
import style1 from "./ScreenReporteVentas.vue?vue&type=style&index=1&id=cb071118&prod&scoped=true&lang=css"
import style2 from "./ScreenReporteVentas.vue?vue&type=style&index=2&id=cb071118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb071118",
  null
  
)

export default component.exports